import { useLocalizedPath } from "../i18n/useLocalizedPath";
import React from "react";
import { Box, Button, Container, Flex, Heading, Text } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SEO from "./SEO";
import Footer from "./Footer";

const NotFound: React.FC = () => {
  const { t } = useTranslation();
  const localizePath = useLocalizedPath();
  return (
    <>
      <SEO title={t("notFound.seoTitle")} description={t("notFound.description")} noindex />
      <Container as="main" maxW="900px" py={{ base: 16, md: 24 }} px={6}>
        <Box bg="white" borderRadius="3xl" p={{ base: 8, md: 14 }} textAlign="center">
          <Text fontSize="5xl" fontWeight="800" color="primary.600" mb={4}>404</Text>
          <Heading as="h1" fontSize={{ base: "2xl", md: "4xl" }}>{t("notFound.title")}</Heading>
          <Text mt={5} color="gray.600" lineHeight="1.9">{t("notFound.description")}</Text>
          <Flex mt={8} gap={4} wrap="wrap" justify="center">
            <Button as={RouterLink} to={localizePath("/")} colorScheme="primary">{t("notFound.home")}</Button>
            <Button as={RouterLink} to={localizePath("/diary-app")} variant="outline" colorScheme="primary">{t("notFound.diary")}</Button>
          </Flex>
        </Box>
      </Container>
      <Footer />
    </>
  );
};

export default NotFound;
